import Navbar from '../navbar/navbar';
import HomePage from '../home/home';
import CategoryPage from '../category/category';
import SubCategory from '../subcategory/subcategory';
import Products from '../products/products';
import Footer from '../footer/footer';
import ScrollToTop from '../scrolltotop/ScrollToTop';
import ProductsDetails from '../productDetails/productDetails';
import Working from '../working/working';
import Faqs from '../faqs/faqs';
import Stores from '../stores/stores';
import ContactUs from '../contactus/contactus';
import AboutUs from '../aboutus/aboutus';
import { LanguageProvider } from '../../context/LanguageContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const MainContent = () => {  
    return (
      <div>
        <BrowserRouter>
          <Navbar />
          <ScrollToTop>
            <Routes>
              <Route exact path="/" element={ <HomePage/>} />
              <Route exact path="/category" element={ <CategoryPage />} />
              <Route exact path="/blog" element={<div>Blog Page</div>} />
              <Route exact path="/aboutus" element={<AboutUs />} />
              <Route exact path="/contactus" element={ <ContactUs />} />
              <Route exact path="/subcategory" element={ <SubCategory />} />
              <Route exact path="/products" element= {<Products />} />
              <Route exact path="/product/:id" element={ <ProductsDetails /> }/>
              <Route exact path="/how-it-works" element={ <Working /> }/>
              <Route exact path="/faqs" element={ <Faqs />} />
              <Route exact path="/stores" element={ <Stores />} />
            </Routes>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </ScrollToTop>
          <Footer />
        </BrowserRouter>
      </div>
    );
};
  
const MainPage = () => (
    <LanguageProvider>
        <MainContent />
    </LanguageProvider>
);

export default MainPage;
